import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/calendar/calendar-navigator.styles.ts
var calendar_navigator_styles_default = r` :host { display: block; } button { margin: 0; } .calendar-navigator { padding: var(--sl-spacing-x-small) 0; display: flex; flex-direction: row; } .calendar-navigator__title { flex: 1; } .calendar-navigator button { cursor: pointer; height: 40px; border: none; background: transparent; border-radius: var(--sl-border-radius-pill); padding: 0 var(--sl-spacing-small); } .calendar-navigator button:hover, .calendar-navigator button:active, .calendar-navigator button:focus, .calendar-navigator button:focus-visible { outline: none; background: var(--sl-color-primary-100); } .calendar-navigator__controls button { height: 40px; width: 40px; border-radius: var(--sl-border-radius-circle); padding: 10px; } `;

export {
  calendar_navigator_styles_default
};
